import React from 'react';
import { Navigate, Outlet } from 'react-router';
import { useUserPermissions } from '../../../hooks/useUserPermissions';

const AdminRoute = () => {
  const { isAuthenticated, isPrometheeAdmin, isAccessTokenPayloadLoading } =
    useUserPermissions();
  if (isAccessTokenPayloadLoading) return null;
  if (!isAuthenticated) return <Navigate to="/auth/login" replace />;
  if (!isPrometheeAdmin) return <Navigate to="/dashboard/products" replace />;
  return <Outlet />;
};

export default AdminRoute;
